import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

class AppErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
    message: ''
  };

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      message: error?.message || 'Something went wrong while loading buSk.'
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('AppErrorBoundary caught an error:', error, errorInfo);
    if (error.name === 'ChunkLoadError') {
      const already = sessionStorage.getItem('chunk_reload');
      if (!already) {
        sessionStorage.setItem('chunk_reload', '1');
        window.location.reload();
      }
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleClearSession = () => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('betaAccess');
      localStorage.removeItem('betaAccessTimestamp');
      sessionStorage.clear();
    } catch (error) {
      console.error('Failed to clear browser storage:', error);
    }
    window.location.replace('/login?forceLogin=1');
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        style={{
          minHeight: '100vh',
          background: 'rgb(20, 20, 22)',
          color: 'rgb(201, 201, 201)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px'
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '420px',
            background: 'rgb(26, 26, 26)',
            border: '1px solid rgba(201, 148, 62, 0.25)',
            borderRadius: '20px',
            padding: '28px',
            textAlign: 'center'
          }}
        >
          <h1 style={{ color: '#c9943e', fontSize: '2rem', marginBottom: '0.5rem' }}>buSk</h1>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>Something went wrong</h2>
          <p style={{ color: 'rgb(150, 150, 150)', lineHeight: 1.5, marginBottom: '1rem' }}>
            The app hit an unexpected client-side error while loading.
          </p>
          <p style={{ color: 'rgb(120, 120, 120)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
            {this.state.message}
          </p>
          <div style={{ display: 'grid', gap: '0.75rem' }}>
            <button
              type="button"
              onClick={this.handleReload}
              style={{
                border: 'none',
                borderRadius: '999px',
                background: '#c9943e',
                color: 'rgb(20, 20, 22)',
                fontWeight: 600,
                padding: '14px 18px',
                cursor: 'pointer'
              }}
            >
              Reload
            </button>
            <button
              type="button"
              onClick={this.handleClearSession}
              style={{
                border: '1px solid rgba(201, 148, 62, 0.35)',
                borderRadius: '999px',
                background: 'transparent',
                color: 'rgb(201, 201, 201)',
                fontWeight: 500,
                padding: '14px 18px',
                cursor: 'pointer'
              }}
            >
              Clear saved session and sign in
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
